import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  // Login
  LOGIN_REQUEST: '',
  LOGIN_SUCCESS: '',
  LOGIN_FAILURE: '',
  LOGIN_TERMS: '',

  UPDATE_TOKEN_IN_STORE: '',

  // Check self
  CHECK_ME_REQUEST: '',
  CHECK_ME_SUCCESS: '',
  CHECK_ME_FAILURE: '',

  // Get self
  GET_ME_REQUEST: '',
  GET_ME_SUCCESS: '',
  GET_ME_FAILURE: '',

  // Logout
  LOGOUT_SUCCESS: '',

  SET_ROLES: '',

  ACCEPTED_TERMS: '',
  DECLINED_TERMS: '',

  SEND_REGISTRATION_REQUEST: '',
  SEND_REGISTRATION_SUCCESS: '',
  SEND_REGISTRATION_FAILURE: '',

  SEND_REGISTRATION_CENTRAL_REQUEST: '',
  SEND_REGISTRATION_CENTRAL_SUCCESS: '',
  SEND_REGISTRATION_CENTRAL_FAILURE: '',

  CHECK_CURRENT_PASSWORD_REQUEST: '',
  CHECK_CURRENT_PASSWORD_SUCCESS: '',
  CHECK_CURRENT_PASSWORD_FAILURE: '',

  CHECK_PASSWORD_HISTORY_REQUEST: '',
  CHECK_PASSWORD_HISTORY_SUCCESS: '',
  CHECK_PASSWORD_HISTORY_FAILURE: '',

  UPDATE_PASSWORD_REQUEST: '',
  UPDATE_PASSWORD_SUCCESS: '',
  UPDATE_PASSWORD_FAILURE: '',

  RESET_PASSWORD_REQUEST: '',
  RESET_PASSWORD_SUCCESS: '',
  RESET_PASSWORD_FAILURE: '',

  FORGOT_PASSWORD_REQUEST: '',
  FORGOT_PASSWORD_SUCCESS: '',
  FORGOT_PASSWORD_FAILURE: '',

  UPDATE_LAST_LOGIN_DATE_REQUEST: '',
  UPDATE_LAST_LOGIN_DATE_SUCCESS: '',
  UPDATE_LAST_LOGIN_DATE_FAILURE: '',

};

types = setStoreTypeValues(types, 'auth');

export default types;
